import OrderService from "@/services/order.service";

const initialState = {
  selectedOrder: {},
  orders: undefined,
  previousOrdersAlert: undefined,
  loading: false,
};

export const orders = {
  namespaced: true,
  state: initialState,
  actions: {
    toggleLoading({ commit }, payload = null) {
      commit("toggleLoading");
    },
    listOrders({ commit, state }, payload = null) {
      /* The cache is for the FIRST paint only. Re-applying it on every call put
         the last fetch back on screen for the length of each request, which
         undid an optimistic pause/hide (the row jumped back to its old tab)
         until the server answered. */
      const jobs = Array.isArray(state.orders) ? null : JSON.parse(localStorage.getItem("jobs"));
      if (jobs) {
        commit("getOrdersSuccess", jobs)
      }

      commit("toggleLoading");
      commit("setPreviousOrdersAlert");
      return OrderService.getOrders().then(
        (orders) => {
          commit("toggleLoading");
          commit("getOrdersSuccess", orders.data);
          localStorage.setItem("jobs", JSON.stringify(orders.data));
          return Promise.resolve(orders.data);
        },
        (error) => {
          commit("toggleLoading");
          commit("getOrdersFailure");
          return Promise.reject(error);
        }
      );
    },
    getOrderById({ commit }, payload = null) {
      return OrderService.getOrderById(payload.id).then((orders) => {
        commit("setOrder", orders.data);
        return Promise.resolve(orders.data);
      });
    },
    pauseOrder({ commit }, payload = null) {
      commit("pauseOrder", payload);
    },
    unpauseOrder({ commit }, payload = null) {
      commit("unpauseOrder", payload);
    },
    archive({ commit }, payload = null) {
      commit("archive", payload);
    },
    unArchive({ commit }, payload = null) {
      commit("unArchive", payload);
    },
  },
  mutations: {
    /*
     * DEAD FOR THE VOTE TOASTS — nothing reads this any more, and nothing should
     * start.
     *
     * It used to be the baseline the "+N votes" diff was computed against, which
     * made it shared mutable state on an action that a dozen unrelated call
     * sites dispatch (pause, resume, hide, the edit modal, the bulk buttons).
     * Any of them landing between a poll's snapshot and its result replaced the
     * baseline underneath it, so a delta was announced twice or lost. The poller
     * in `useVoteActivity` keeps its own private snapshot of the last result it
     * announced, which nothing outside can move.
     *
     * Left in place rather than deleted because removing a commit from an action
     * with that many callers is a separate change with its own blast radius.
     */
    setPreviousOrdersAlert(state) {
      state.previousOrdersAlert = state.orders ? state.orders : undefined;
    },
    toggleLoading(state) {
      state.loading = !state.loading;
    },
    getOrdersSuccess(state, orders) {
      state.orders = orders;
    },
    getOrdersFailure(state) {
      // state.orders = {};
    },
    setOrder(state, order) {
      state.selectedOrder = order;
    },
    /* By order id. These took an index, and the index callers had was the row's
       position on the current PAGE of the current TAB — so they flipped
       whichever unrelated order sat at that position in the full list. */
    pauseOrder(state, id) {
      const order = state.orders?.find((o) => o.id === id);
      if (order) order.running = 0;
    },
    unpauseOrder(state, id) {
      const order = state.orders?.find((o) => o.id === id);
      if (order) order.running = 1;
    },
    archive(state, id) {
      const order = state.orders?.find((o) => o.id === id);
      if (order) order.archive = 1;
    },
    unArchive(state, id) {
      const order = state.orders?.find((o) => o.id === id);
      if (order) order.archive = 0;
    },
  },
};
